/**
 * Every catalogue, imported so the bundler hashes them like any other asset.
 *
 * Bundled rather than fetched at runtime on purpose: two languages of a couple
 * of hundred strings is a few kilobytes, and lazy loading would buy a loading
 * state and a cache-invalidation problem in exchange for nothing.
 *
 * `en` is the reference catalogue — `i18next.d.ts` derives the key types from
 * it, so a key that exists here is the only kind `t()` will accept.
 */
import enAudit from './locales/en/audit.json';
import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enErrors from './locales/en/errors.json';
import enFiles from './locales/en/files.json';
import enInbox from './locales/en/inbox.json';
import enNav from './locales/en/nav.json';
import enNotifications from './locales/en/notifications.json';
import enPeople from './locales/en/people.json';
import enSchedules from './locales/en/schedules.json';
import enSystem from './locales/en/system.json';

import csAudit from './locales/cs/audit.json';
import csAuth from './locales/cs/auth.json';
import csCommon from './locales/cs/common.json';
import csErrors from './locales/cs/errors.json';
import csFiles from './locales/cs/files.json';
import csInbox from './locales/cs/inbox.json';
import csNav from './locales/cs/nav.json';
import csNotifications from './locales/cs/notifications.json';
import csPeople from './locales/cs/people.json';
import csSchedules from './locales/cs/schedules.json';
import csSystem from './locales/cs/system.json';

import { MODULE_LOCALES } from '../modules/locales';

/** The reference catalogue. Its shape is the contract `t()` is checked against. */
export const en = {
  common: enCommon,
  nav: enNav,
  errors: enErrors,
  auth: enAuth,
  system: enSystem,
  files: enFiles,
  people: enPeople,
  notifications: enNotifications,
  inbox: enInbox,
  schedules: enSchedules,
  audit: enAudit,
  // Every module's namespace, so its keys are typed like core's. See ../modules/.
  ...MODULE_LOCALES.en,
} as const;

export const cs = {
  common: csCommon,
  nav: csNav,
  errors: csErrors,
  auth: csAuth,
  system: csSystem,
  files: csFiles,
  people: csPeople,
  notifications: csNotifications,
  inbox: csInbox,
  schedules: csSchedules,
  audit: csAudit,
  ...MODULE_LOCALES.cs,
};

export const resources = { en, cs };
